import React, { useEffect } from 'react';
import SelectAccount from './components/SelectAccount';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import { CircularProgress } from '@material-ui/core';

import { actions as reduxActions } from './reducers';
import styles from './styles';
import { getConnections } from './actions/getConnections';
import { getAccounts } from './actions/getAccounts';
import ConnectionsTable from './components/ConnectionsTable';

const Connections = ({
  classes,
  resetConnections,
  getConnections,
  clientId,
  isLoading,
  refresh,
  setRefresh,
  getAccounts
}) => {
  useEffect(() => {
    getAccounts({ clientId });
    getConnections({ clientId });
    return resetConnections;
    // eslint-disable-next-line
  }, [clientId]);

  useEffect(() => {
    if (refresh) {
      getConnections({ clientId });
      setRefresh(false);
    }
    // eslint-disable-next-line
  }, [refresh]);

  return (
    <>
      <div className={classes.root}>
        {isLoading && (
          <div className={classes.loaderOverlay}>
            <CircularProgress />
          </div>
        )}
        <SelectAccount />
        <ConnectionsTable />
      </div>
    </>
  );
};

const mapStatesToProps = ({ selectClient, connections, loader }) => {
  return {
    clientId: selectClient.selectedClient.id,
    isLoading: loader.isSpinVisible,
    refresh: connections.refresh
  };
};

const mapDispatchToProps = {
  resetConnections: reduxActions.resetConnections,
  getConnections,
  getAccounts,
  setRefresh: reduxActions.setRefresh
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(Connections);
